export default __webpack_public_path__ + "static/media/cut out.965e170f.jpg";